import { END_POINTS } from "../../constants/url";
import { del, formDataPost, formDataPut, get, post, put } from "../../utils/AxiosMethods"

export const GetDashboard = async ({ filterBy }: { filterBy: string; }) => {
    try {
        const response = await get(END_POINTS.dashboard, { filterBy });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetUsers = async ({ limit, skip, search, level, startDate, endDate, lastActiveSortStatus }: { limit: number; skip: number; search: string; level: string, startDate: string, endDate: string; lastActiveSortStatus: number }) => {
    try {
        const response = await get(END_POINTS.user, { limit, skip, search, level, startDate, endDate, lastActiveSortStatus });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetUser = async (id: string) => {
    try {
        const response = await get(`${END_POINTS.user}/${id}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const SearchUsersForAutocomplete = async ({ search, limit }: { search: string; limit?: number }) => {
    try {
        const response = await get(END_POINTS.userSearch, { search, limit: limit || 10 });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const UpdateUserStatus = async (id: string, body: { status: string }) => {
    try {
        const response = await put(`${END_POINTS.updateUser}/${id}`, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const UpdateUserLevel = async (id: string, body: { level: string }) => {
    try {
        const response = await put(`${END_POINTS.updateUser}/${id}`, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const ResetAnonymousQuota = async (id: string) => {
    try {
        const response = await put(`${END_POINTS.resetAnonymousQuota}/${id}`, {});
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetDiscussions = async ({ limit, skip, search, startDate, endDate, sortBy }: { limit: number; skip: number; search: string; startDate?: string, endDate?: string; sortBy: string }) => {
    try {
        const response = await get(END_POINTS.discussion, { limit, skip, search, startDate, endDate, sortBy });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetDiscussionById = async ({ postId }: { postId: string }) => {
    try {
        const response = await get(`${END_POINTS.discussion}/${postId}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetComments = async ({ limit, skip, search, startDate, endDate, likes }: { limit: number; skip: number; search: string; likes: string; startDate?: string, endDate?: string }) => {
    try {
        const response = await get(END_POINTS.comment, { limit, skip, search, likes, startDate, endDate });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetCommentById = async ({ commentId }: { commentId: string }) => {
    try {
        const response = await get(`${END_POINTS.comment}/${commentId}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const UpdateCommentStatus = async (id: string, body: any) => {
    try {
        const response = await put(`${END_POINTS.updateComment}/${id}`, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetPosts = async ({ limit, skip, search, contentType, startDate, endDate, status, categoryId }: { limit: number; skip: number; search: string; status: string; contentType: string; startDate?: string, endDate?: string; categoryId?: string }) => {
    try {
        const response = await get(END_POINTS.post, { limit, skip, search, contentType, status, categoryId, startDate, endDate });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetPostById = async ({ postId }: { postId: string }) => {
    try {
        const response = await get(`${END_POINTS.post}/${postId}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const UpdatePostStatus = async (id: string, body: { status: string }) => {
    try {
        const response = await put(`${END_POINTS.updatePost}/${id}`, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetAvatars = async () => {
    try {
        const response = await get(`${END_POINTS.post}/avatars`);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GenerateAvatarVideo = async (postId: string, avatarId: string) => {
    try {
        const response = await post(`${END_POINTS.post}/${postId}/generate-video`, { avatarId });
        return response;
    } catch (error) {
        console.log(error);
    }
}
export const UpdateDiscussionStatus = async (id: string, body: { status: string }) => {
    try {
        const response = await put(`${END_POINTS.discussionUpdate}/${id}`, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}
export const GetCategories = async (params?: { parentCategoryId?: string | null }) => {
    try {
        const response = await get(END_POINTS.categories, params ?? {});
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const AddCategory = async (body: { name: string; description?: string; parentCategoryId?: string | null; categoryPassword: string }) => {
    try {
        const response = await post(END_POINTS.categories, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const UpdateCategory = async (id: string, body: { name?: string; description?: string; parentCategoryId?: string | null; categoryPassword: string }) => {
    try {
        const response = await put(`${END_POINTS.categories}/${id}`, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const DeleteCategory = async (id: string, body: { categoryPassword: string }) => {
    try {
        const response = await del(`${END_POINTS.categories}/${id}`, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetTransactions = async ({ limit, search, skip, platform, startDate, endDate }: { limit: number; skip: number; search: string, platform: string, startDate?: string, endDate?: string; }) => {
    try {
        const response = await get(`${END_POINTS.subscription}?status=""&limit=${limit}&skip=${skip}&search=${search}&platform=${platform}&startDate=${startDate}&endDate=${endDate}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const AddPost = async (body: FormData) => {
    try {
        const response = await formDataPost(END_POINTS.addPost, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const UpdatePost = async (body: FormData, postId: string) => {
    try {
        const response = await formDataPut(`${END_POINTS.addPost}/${postId}`, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const PostLikes = async (postId: string) => {
    try {
        const response = await get(`${END_POINTS.postLike}/${postId}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const DuplicatePost = async (postId: string) => {
    try {
        const response = await post(`${END_POINTS.post}/${postId}/duplicate`, {});
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const DeletePost = async (postId: string) => {
    try {
        const response = await del(`${END_POINTS.deletePost}/${postId}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const AddFcm = async (body: any) => {
    try {
        const response = await post(END_POINTS.addFcm, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetNotificationCount = async () => {
    try {
        const response = await get(`${END_POINTS.notificationCount}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetNotifications = async ({limit,skip} : {limit: number; skip: number}) => {
    try {
        const response = await get(`${END_POINTS.notification}` , {limit, skip});
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const UpdateNotification = async (body: { notificationId: string, isRead: boolean }) => {
    try {
        const response = await put(`${END_POINTS.notification}`, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetSubscriptionById = async (userId:any ) => {
    try {
        const response = await get(`${END_POINTS.subscription}/${userId}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}

// News
export const GetNews = async ({ limit, skip, search, status }: { limit: number; skip: number; search: string; status: string }) => {
    try {
        const response = await get(END_POINTS.news, { limit, skip, search, status });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetNewsById = async (id: string) => {
    try {
        const response = await get(`${END_POINTS.news}/${id}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const AddNews = async (body: { title: string; description: string; status: string }) => {
    try {
        const response = await post(END_POINTS.news, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const UpdateNews = async (id: string, body: { title?: string; description?: string; status?: string }) => {
    try {
        const response = await put(`${END_POINTS.news}/${id}`, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const UpdateNewsStatus = async (id: string, body: { status: string }) => {
    try {
        const response = await put(`${END_POINTS.newsStatus}/${id}`, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const DeleteNews = async (id: string) => {
    try {
        const response = await del(`${END_POINTS.news}/${id}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}